/*
 * MDB shim for MDBDataTable
 * Files currently importing this symbol from "mdbreact":
 * - src/Components/Pipeline/MonthGlance.jsx
 * - src/Seating/Deliveries/inventoryTracking.jsx
 */

import MUITable from "@mui/material/Table";
import MUITableBody from "@mui/material/TableBody";
import MUITableCell from "@mui/material/TableCell";
import MUITableHead from "@mui/material/TableHead";
import MUITableRow from "@mui/material/TableRow";

export default function MDBDataTable({
  columns = [],
  rows = [],
  data,
  ...rest
}) {
  const resolvedColumns = columns.length ? columns : data?.columns || [];
  const resolvedRows = rows.length ? rows : data?.rows || [];

  return (
    <MUITable {...rest}>
      <MUITableHead>
        <MUITableRow>
          {resolvedColumns.map((column, index) => (
            <MUITableCell key={column.field || column.label || index}>
              {column.label || column.field || ""}
            </MUITableCell>
          ))}
        </MUITableRow>
      </MUITableHead>
      <MUITableBody>
        {resolvedRows.map((row, rowIndex) => (
          <MUITableRow key={row.id || rowIndex}>
            {resolvedColumns.map((column, colIndex) => {
              const key = column.field || column.label || colIndex;
              const value = column.field ? row[column.field] : row[key];

              return (
                <MUITableCell key={`${key}-${colIndex}`}>{value}</MUITableCell>
              );
            })}
          </MUITableRow>
        ))}
      </MUITableBody>
    </MUITable>
  );
}
